/**
 * Real cap is 4.9 MB; the user-facing message in site messages reads 5 MB.
 * maxSizeBytes is the per-file cap; maxTotalSizeBytes caps the sum of all attachments
 * (the whole multipart request must stay under the 5 MB Optimizely server limit).
 */
export const ATTACHMENT_LIMITS = {
    maxSizeBytes: 4_900_000,
    maxTotalSizeBytes: 4_900_000,
    maxFileCount: 5,
    allowedMimeTypes: [
        "image/jpeg",
        "image/tiff",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    allowedExtensions: [".jpg", ".jpeg", ".tif", ".tiff", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"],
} as const;
